import { render } from "./EdmSentResultCard.vue?vue&type=template&id=01ee958f"
import script from "./EdmSentResultCard.vue?vue&type=script&lang=js"
export * from "./EdmSentResultCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__